import { limit } from 'firebase/firestore';
import { INotificationSettings, IUser } from 'src/app/core/user/models/user';

import { Injectable } from '@angular/core';
import { and, DocumentReference, getDocs, or, query, where } from '@angular/fire/firestore';
import { FireStoreCollection } from '@shared/models/firestore';
import { IMobileNumber } from '@shared/models/numbers';
import { FirestoreService } from '@shared/services/firestore/firestore.service';

@Injectable({
	providedIn: 'root',
})
export class UsersService extends FirestoreService<IUser> {
	constructor() {
		super(FireStoreCollection.USERS);
	}

	async userByEmail(email: string): Promise<IUser | null> {
		const q = query(this.collectionRef, where('email', '==', email));
		return getDocs(q).then((snapshot) => {
			if (!snapshot.empty) {
				return snapshot.docs[0].data();
			}
			return null;
		});
	}

	async userByPhoneNumber(phoneNumber: IMobileNumber): Promise<IUser | null> {
		const q = query(this.collectionRef, where('phoneNumber.e164Number', '==', phoneNumber.e164Number));
		return getDocs(q).then((snapshot) => {
			if (!snapshot.empty) {
				return snapshot.docs[0].data();
			}
			return null;
		});
	}

	getUserByRef(userRef: DocumentReference) {
		return this.getDocSnapshot(userRef.id);
	}

	getUserById(userId: string) {
		return this.getDocSnapshot(userId);
	}

	async updateUserNotificationSettings(userId: string, notificationSettings: INotificationSettings): Promise<void> {
		await this.update(userId, { settings: { notifications: notificationSettings } });
	}

	async searchUsers(searchTerm: string): Promise<IUser[]> {
		if (!searchTerm || searchTerm.length < 3) {
			return Promise.resolve([]);
		}
		const q = query(
			this.collectionRef,
			or(
				and(where('displayName', '>=', searchTerm), where('displayName', '<=', searchTerm + '\uf8ff')),
				and(where('email', '>=', searchTerm), where('email', '<=', searchTerm + '\uf8ff')),
				and(where('phoneNumber.e164Number', '>=', searchTerm), where('phoneNumber.e164Number', '<=', searchTerm + '\uf8ff')),
				and(
					where('phoneNumber.nationalNumber', '>=', searchTerm),
					where('phoneNumber.nationalNumber', '<=', searchTerm + '\uf8ff'),
				),
			),
			limit(10),
		);
		return getDocs(q).then((snapshot) => {
			return snapshot.docs.map((doc) => doc.data());
		});
	}
}
